export const capitalizeFirstLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const textWithLinks = (text: string): string => {
  return text.replace(
    /\b(https?:\/\/)?[^\s]+[^.\s]\.[^.\s][^\s.]{2,}\b/g,
    linkify,
  )
}

const linkify = (link: string): string => {
  let newLink = link
  newLink = newLink.replace('http:', 'https:')
  if (link.indexOf('http') !== 0) {
    newLink = `https://${link}`
  }
  return `<a href="${newLink}" data-bypass="true" rel="noopener noreferrer" target="_blank">${link}</a>`
}

export const copyToClipboard = (value: string) => {
  const activeElement: any = document.activeElement
  const textarea = document.createElement('textarea')
  textarea.style.cssText = 'position: absolute; left: -99999em'
  // prevent iOS keyboard from popping up
  textarea.setAttribute('readonly', 'true')
  document.body.appendChild(textarea)
  textarea.value = value
  textarea.focus()
  textarea.select()
  try {
    document.execCommand('copy')
  } catch (e) {
    // console.log('copy error', e)
  }
  document.body.removeChild(textarea)
  activeElement.focus()
}

export const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const replaceVariable = (variable, text, model, prop) => {
  if (model && model[prop]) {
    const re = new RegExp(variable.replace('$', '\\$'), 'g')
    return text.replace(re, model[prop])
  }
  return text
}

export const replaceVariables = (text, patient, providerProfile) => {
  let replaceText = text
  if (/\$[A-Z|_]+/.test(replaceText)) {
    // provider
    replaceText = replaceVariable(
      '$MY_FIRST_NAME',
      replaceText,
      providerProfile,
      'firstName',
    )
    replaceText = replaceVariable(
      '$PROVIDER_FIRST_NAME',
      replaceText,
      providerProfile,
      'firstName',
    )
    replaceText = replaceVariable(
      '$MY_LAST_NAME',
      replaceText,
      providerProfile,
      'lastName',
    )
    replaceText = replaceVariable(
      '$PROVIDER_LAST_NAME',
      replaceText,
      providerProfile,
      'lastName',
    )
    // patient
    replaceText = replaceVariable(
      '$PATIENT_FIRST_NAME',
      replaceText,
      patient,
      'firstName',
    )
    replaceText = replaceVariable(
      '$PATIENT_LAST_NAME',
      replaceText,
      patient,
      'lastName',
    )
  }
  return replaceText
}

